import CarouselAbstr, { CarouselOptions } from '../CarouselAbstr';
import Slide from '../Slide';

export default class productCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);

		this.init();
	}

	protected init(): void {
		const slidesColl = this.carouselEl.getElementsByClassName('productCarousel__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;
			this.slides.push(new Slide({ element, isActive }));
		}

		if (this.slides.length === 1)
			return;

		document.querySelector('.productCarousel__frame').appendChild(this.buildControls());

		this.initAutoAdvance();
	}
}
